export enum TableFilters {
  All,
  InBackup,
  NotInBackup,
  InBackupNotInDomain,
  Suspended
}
